// Ticket:tickets

import Vue from "vue";
import firebase from "firebase/compat/app"

export default {
};

export const database = {
	install(Vue) {
		Vue.prototype.$database = {
			currentTimestamp: function () {
				return firebase.firestore.Timestamp.now();
			},
			dateToTimestamp: function (date) {
				return firebase.firestore.Timestamp.fromDate(new Date(date));
			},
			timestampToDate: function (timestamp) {
				return timestamp.toDate();
			},
			onTickets: function (onSnapshot) {
				return firebase.firestore()
					.collection('tickets')
					.onSnapshot(onSnapshot);
			},
			loadTickets: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('tickets')
					.orderBy('createAt', 'desc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadTicket: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('tickets')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addTicket: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('tickets')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editTicket: async function (id, model) {
				await firebase.firestore()
					.collection('tickets')
					.doc(id)
					.update(model);
			},
			deleteTicket: async function (id) {
				await firebase.firestore()
					.collection('tickets')
					.doc(id)
					.delete();
			},
			setTicket: async function (id, model) {
				await firebase.firestore()
					.collection('tickets')
					.doc(id)
					.set(model);
			},
			onGeneralConfigs: function (onSnapshot) {
				return firebase.firestore()
					.collection('generalConfigs')
					.onSnapshot(onSnapshot);
			},
			loadGeneralConfigs: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('generalConfigs');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadGeneralConfig: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('generalConfigs')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addGeneralConfig: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('generalConfigs')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editGeneralConfig: async function (id, model) {
				await firebase.firestore()
					.collection('generalConfigs')
					.doc(id)
					.update(model);
			},
			deleteGeneralConfig: async function (id) {
				await firebase.firestore()
					.collection('generalConfigs')
					.doc(id)
					.delete();
			},
			setGeneralConfig: async function (id, model) {
				await firebase.firestore()
					.collection('generalConfigs')
					.doc(id)
					.set(model);
			},
			onUsers: function (onSnapshot) {
				return firebase.firestore()
					.collection('users')
					.onSnapshot(onSnapshot);
			},
			loadUsers: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('users');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadConsultants: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('users')
					.where('userType', '==', 'UserType.consultant')
					.orderBy('order', 'asc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadDoctors: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('users')
					.where('userType', '==', 'UserType.doctor')
					.orderBy('order', 'asc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadCustomers: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('users')
					.where('userType', '==', 'UserType.appUser');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadUser: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('users')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addUser: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('users')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editUser: async function (id, model) {
				await firebase.firestore()
					.collection('users')
					.doc(id)
					.update(model);
			},
			deleteDoctor: async function (id) {
				await firebase.firestore()
					.collection('users')
					.doc(id)
					.delete();
				await firebase.firestore()
					.collection('users')
					.where('doctorId', '==', id)
					.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let user = querySnapshot.docs[i].data();
							await firebase.firestore()
								.collection('users')
								.doc(user.id)
								.update({ 'doctorId': null });
						}
					});
			},
			deleteConsultant: async function (id) {
				await firebase.firestore()
					.collection('users')
					.doc(id)
					.delete();
				await firebase.firestore()
					.collection('users')
					.where('consultantId', '==', id)
					.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let user = querySnapshot.docs[i].data();
							await firebase.firestore()
								.collection('users')
								.doc(user.id)
								.update({ 'consultantId': null });
						}
					});
			},
			setUser: async function (id, model) {
				await firebase.firestore()
					.collection('users')
					.doc(id)
					.set(model);
			},
			onReviewScores: function (onSnapshot) {
				return firebase.firestore()
					.collection('reviewScores')
					.onSnapshot(onSnapshot);
			},
			loadReviewScores: async function (consultantId, limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('reviewScores')
					.where('doctorId', '==', consultantId)
					.orderBy('createAt', 'desc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadReviewScore: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('reviewScores')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addReviewScore: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('reviewScores')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editReviewScore: async function (id, model) {
				await firebase.firestore()
					.collection('reviewScores')
					.doc(id)
					.update(model);
			},
			deleteReviewScore: async function (id) {
				await firebase.firestore()
					.collection('reviewScores')
					.doc(id)
					.delete();
			},
			setReviewScore: async function (id, model) {
				await firebase.firestore()
					.collection('reviewScores')
					.doc(id)
					.set(model);
			},
			onConsultations: function (consultantId, userId, orderBy, onSnapshot, limit) {
				let ref = firebase.firestore()
					.collection('consultations')
					.where('consultantId', '==', consultantId);
				if (userId != null) {
					ref = ref.where('userId', '==', userId);
				}
				ref = ref.orderBy('reservationAt', orderBy);
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref.onSnapshot(onSnapshot);
			},
			onConsultationsForDoctor: function (doctorId, userId, orderBy, onSnapshot, limit) {
				let ref = firebase.firestore()
					.collection('consultations')
					.where('doctorId', '==', doctorId);
				if (userId != null) {
					ref = ref.where('userId', '==', userId);
				}
				ref = ref.orderBy('reservationAt', orderBy);
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref.onSnapshot(onSnapshot);
			},
			onAllConsultations: function (consultantId, userId, orderBy, onSnapshot, limit) {
				let ref = firebase.firestore()
					.collection('consultations');
				if (consultantId != null) {
					ref = ref.where('consultantId', '==', consultantId);
				}
				if (userId != null) {
					ref = ref.where('userId', '==', userId);
				}
				ref = ref.orderBy('reservationAt', orderBy);
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref.onSnapshot(onSnapshot);
			},
			loadConsultations: async function (consultantId, limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('consultations');
				if (consultantId != null) {
					ref = ref.where('consultantId', '==', consultantId);
				}
				ref = ref.orderBy('createAt', 'asc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadConsultationsForDoctor: async function (doctorId, limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('consultations')
					.where('doctorId', '==', doctorId);
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadConsultationsForUser: async function (userId, limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('consultations')
					.where('userId', '==', userId);
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref = ref.orderBy('createAt', 'desc');
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadConsultationsFromDate: async function (startDate, endDate) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('consultations')
					.where('consultationEndAt', '>=', startDate)
					.where('consultationEndAt', '<=', endDate);
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadConsultation: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('consultations')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addConsultation: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('consultations')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editConsultation: async function (id, model) {
				await firebase.firestore()
					.collection('consultations')
					.doc(id)
					.update(model);
			},
			deleteConsultation: async function (id) {
				await firebase.firestore()
					.collection('consultations')
					.doc(id)
					.delete();
			},
			setConsultation: async function (id, model) {
				await firebase.firestore()
					.collection('consultations')
					.doc(id)
					.set(model);
			},
			loadPayments: async function (consultantId, limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('payments');
				if (consultantId != null) {
					ref = ref.where('consultantId', '==', consultantId);
				}
				ref = ref.where('state', '==', 'PaymentState.ok');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadPaymentsFromDate: async function (startDate, endDate) {
				let itemList = [];
				await firebase.firestore()
					.collection('payments')
					.where('paymentAt', '>=', startDate)
					.where('paymentAt', '<=', endDate)
					.where('state', '==', 'PaymentState.ok')
					.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadLastCustomerConsultations: async function (consultantId, userId) {
				let item = null;
				let ref = firebase.firestore()
					.collection('consultantHistorys')
					.where('consultantId', '==', consultantId)
					.where('userId', '==', userId)
					.orderBy('assignAt', 'desc')
					.limit(1);
				await ref.get()
					.then(async (querySnapshot) => {
						if (querySnapshot.docs.length > 0) {
							item = querySnapshot.docs[0].data();
						}
					});
				return item;
			},
			loadLastCustomerConsultationsForDoctor: async function (doctorId, userId) {
				let item = null;
				let ref = firebase.firestore()
					.collection('consultantHistorys')
					.where('doctorId', '==', doctorId)
					.where('userId', '==', userId)
					.orderBy('assignAt', 'desc')
					.limit(1);
				await ref.get()
					.then(async (querySnapshot) => {
						if (querySnapshot.docs.length > 0) {
							item = querySnapshot.docs[0].data();
						}
					});
				return item;
			},
			loadConsultantHistorys: async function (userId) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('consultantHistorys')
					.where('userId', '==', userId)
					.orderBy('assignAt', 'desc');
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			changeConsultant: async function (appUserId, beforeConsultantId, newConsultant) {
				let appUserRef = firebase.firestore()
					.collection('users')
					.doc(appUserId);
				let consultantHistoryRef = firebase.firestore()
					.collection('consultantHistorys')
					.doc();
				let consultantRef = firebase.firestore()
					.collection('users')
					.doc(newConsultant.id);
				await firebase.firestore().runTransaction(async (transaction) => {
					return transaction.get(appUserRef).then(async () => {
						await firebase.firestore()
							.collection('consultations')
							.where('userId', '==', appUserId)
							.where('consultantId', '==', beforeConsultantId)
							.where('state', '!=', 'ConsultantState.finished')
							.get()
							.then(async (querySnapshot) => {
								for (let i = 0; i < querySnapshot.docs.length; i++) {
									let consultation = querySnapshot.docs[i].data();
									let consultationRef = firebase.firestore()
										.collection('consultations')
										.doc(consultation.id);
									if (beforeConsultantId != null) {
										transaction.update(consultationRef, {
											consultantId: newConsultant.id,
											consultant: newConsultant,
										});
									}
									else {
										transaction.update(consultationRef, {
											consultantId: newConsultant.id,
											consultant: newConsultant,
											state: 'ConsultationState.reservation',
											reservationAt: consultation.reservationRequestAt1,
										});
									}
								}
							});

						transaction.update(appUserRef, {
							consultantId: newConsultant.id,
						});

						transaction.set(consultantHistoryRef, {
							id: consultantHistoryRef.id,
							createAt: firebase.firestore.Timestamp.now(),
							userId: appUserId,
							consultantId: newConsultant.id,
							assignAt: firebase.firestore.Timestamp.now(),
						});

						transaction.update(consultantRef, {
							customers: firebase.firestore.FieldValue.arrayUnion(appUserId),
						});
					});
				});
			},
			changeDoctor: async function (appUserId, beforeDoctorId, newDoctor) {
				let appUserRef = firebase.firestore()
					.collection('users')
					.doc(appUserId);
				let consultantHistoryRef = firebase.firestore()
					.collection('consultantHistorys')
					.doc();
				let doctorRef = firebase.firestore()
					.collection('users')
					.doc(newDoctor.id);
				await firebase.firestore().runTransaction(async (transaction) => {
					return transaction.get(appUserRef).then(async () => {
						await firebase.firestore()
							.collection('consultations')
							.where('state', '!=', 'ConsultantState.finished')
							.where('type', '==', 'ConsultationType.clinic')
							.where('userId', '==', appUserId)
							.where('doctorId', '==', beforeDoctorId)
							.get()
							.then(async (querySnapshot) => {
								for (let i = 0; i < querySnapshot.docs.length; i++) {
									let consultation = querySnapshot.docs[i].data();
									let consultationRef = firebase.firestore()
										.collection('consultations')
										.doc(consultation.id);
									if (beforeDoctorId != null) {
										transaction.update(consultationRef, {
											doctorId: newDoctor.id,
											doctor: newDoctor,
										});
									}
									else {
										transaction.update(consultationRef, {
											doctorId: newDoctor.id,
											doctor: newDoctor,
											state: 'ConsultationState.reservation',
											reservationAt: consultation.reservationRequestAt1,
										});
									}
								}
							});

						transaction.update(appUserRef, {
							doctorId: newDoctor.id,
						});

						transaction.set(consultantHistoryRef, {
							id: consultantHistoryRef.id,
							createAt: firebase.firestore.Timestamp.now(),
							userId: appUserId,
							doctorId: newDoctor.id,
							assignAt: firebase.firestore.Timestamp.now(),
						});

						transaction.update(doctorRef, {
							customers: firebase.firestore.FieldValue.arrayUnion(appUserId),
						});
					});
				});
			},
			onSolutions: function (onSnapshot) {
				return firebase.firestore()
					.collection('solutions')
					.onSnapshot(onSnapshot);
			},
			loadSolutions: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('solutions');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref = ref.orderBy('order', 'asc');
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadSolution: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('solutions')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addSolution: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('solutions')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editSolution: async function (id, model) {
				await firebase.firestore()
					.collection('solutions')
					.doc(id)
					.update(model);
			},
			deleteSolution: async function (id) {
				await firebase.firestore()
					.collection('solutions')
					.doc(id)
					.delete();
			},
			setSolution: async function (id, model) {
				await firebase.firestore()
					.collection('solutions')
					.doc(id)
					.set(model);
			},
			onTreatmentCases: function (onSnapshot) {
				return firebase.firestore()
					.collection('treatmentCases')
					.onSnapshot(onSnapshot);
			},
			loadTreatmentCases: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('treatmentCases');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref = ref.orderBy('order', 'asc');
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadTreatmentCase: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('treatmentCases')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addTreatmentCase: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('treatmentCases')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editTreatmentCase: async function (id, model) {
				await firebase.firestore()
					.collection('treatmentCases')
					.doc(id)
					.update(model);
			},
			deleteTreatmentCase: async function (id) {
				await firebase.firestore()
					.collection('treatmentCases')
					.doc(id)
					.delete();
			},
			setTreatmentCase: async function (id, model) {
				await firebase.firestore()
					.collection('treatmentCases')
					.doc(id)
					.set(model);
			},
			onNotices: function (onSnapshot) {
				return firebase.firestore()
					.collection('notices')
					.onSnapshot(onSnapshot);
			},
			loadNotices: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('notices');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref = ref.orderBy('createAt', 'desc');
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadNotice: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('notices')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addNotice: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('notices')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editNotice: async function (id, model) {
				await firebase.firestore()
					.collection('notices')
					.doc(id)
					.update(model);
			},
			deleteNotice: async function (id) {
				await firebase.firestore()
					.collection('notices')
					.doc(id)
					.delete();
			},
			setNotice: async function (id, model) {
				await firebase.firestore()
					.collection('notices')
					.doc(id)
					.set(model);
			},
			onPayments: function (onSnapshot) {
				return firebase.firestore()
					.collection('payments')
					.onSnapshot(onSnapshot);
			},
			loadAllPayments: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('payments');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				ref = ref.orderBy('createAt', 'desc');
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadPayment: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('payments')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addPayment: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('payments')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editPayment: async function (id, model) {
				await firebase.firestore()
					.collection('payments')
					.doc(id)
					.update(model);
			},
			deletePayment: async function (id) {
				await firebase.firestore()
					.collection('payments')
					.doc(id)
					.delete();
			},
			setPayment: async function (id, model) {
				await firebase.firestore()
					.collection('payments')
					.doc(id)
					.set(model);
			},
			onChatRooms: function (onSnapshot) {
				return firebase.firestore()
					.collection('chatRooms')
					.where('type', '==', 'ChatRoomType.service')
					.orderBy('updateAt', 'desc')
					.onSnapshot(onSnapshot);
			},
			onNewChatRoom: function (onSnapshot) {
				return firebase.firestore()
					.collection('chatRooms')
					.where('type', '==', 'ChatRoomType.service')
					.where('memberRecentSeenById', '==', null)
					.orderBy('createAt', 'desc')
					.onSnapshot(onSnapshot);
			},
			loadChatRooms: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('chatRooms')
					.where('type', '==', 'ChatRoomType.service')
					.orderBy('updateAt', 'desc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadChatRoom: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('chatRooms')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addChatRoom: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('chatRooms')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editChatRoom: async function (id, model) {
				await firebase.firestore()
					.collection('chatRooms')
					.doc(id)
					.update(model);
			},
			deleteChatRoom: async function (id) {
				await firebase.firestore()
					.collection('chatRooms')
					.doc(id)
					.delete();
			},
			setChatRoom: async function (id, model) {
				await firebase.firestore()
					.collection('chatRooms')
					.doc(id)
					.set(model);
			},
			addChatMessage: async function (chatRoomId, model, notificationMessage, receiverUid, chatRoomType) {
				let newDocRef = firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId)
					.collection('chatMessages')
					.doc();
				let chatRoomRef = firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId);
				let notificationRef = firebase.firestore()
					.collection('notifications')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await firebase.firestore().runTransaction(async (transaction) => {
					return transaction.get(chatRoomRef).then(async (chatRoomDoc) => {
						if (chatRoomDoc.exists) {
							transaction.set(newDocRef, addModel);
							transaction.update(chatRoomRef, {
								'updateAt': firebase.firestore.Timestamp.now(),
								'lastMessage': addModel.message,
								'lastMessageModel': addModel,
								'memberRecentSeenById.admin': firebase.firestore.Timestamp.now(),
							});
							if ((notificationMessage != undefined) && (notificationMessage != null)) {
								transaction.set(notificationRef, {
									createAt: firebase.firestore.Timestamp.now(),
									title: addModel.authorNickname,
									message: notificationMessage,
									additionalData: {
										type: "NotificationType.chat",
										chatRoomId: chatRoomId,
										authorId: addModel.authorId,
										chatRoomType: chatRoomType
									},
									receiverUid: receiverUid,
									topic: '',
								});
							}
						}
					});
				});
			},
			onChatMessages: function (chatRoomId, onSnapshot) {
				return firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId)
					.collection('chatMessages')
					.orderBy('createAt', 'asc')
					.onSnapshot(onSnapshot);
			},
			loadChatMessages: async function (chatRoomId, limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId)
					.collection('chatMessages')
					.orderBy('createAt', 'asc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadChatMessage: async function (chatRoomId, id) {
				let item = null;
				await firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId)
					.collection('chatMessages')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			editChatMessage: async function (chatRoomId, id, model) {
				await firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId)
					.collection('chatMessages')
					.doc(id)
					.update(model);
			},
			deleteChatMessage: async function (chatRoomId, id) {
				await firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId)
					.collection('chatMessages')
					.doc(id)
					.delete();
			},
			setChatMessage: async function (chatRoomId, id, model) {
				await firebase.firestore()
					.collection('chatRooms')
					.doc(chatRoomId)
					.collection('chatMessages')
					.doc(id)
					.set(model);
			},
			onNotificationSchedules: function (onSnapshot) {
				return firebase.firestore()
					.collection('notificationSchedules')
					.onSnapshot(onSnapshot);
			},
			loadNotificationSchedules: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('notificationSchedules')
					.orderBy('createAt', 'desc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadNotificationSchedule: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('notificationSchedules')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addNotificationSchedule: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('notificationSchedules')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editNotificationSchedule: async function (id, model) {
				await firebase.firestore()
					.collection('notificationSchedules')
					.doc(id)
					.update(model);
			},
			deleteNotificationSchedule: async function (id) {
				await firebase.firestore()
					.collection('notificationSchedules')
					.doc(id)
					.delete();
			},
			setNotificationSchedule: async function (id, model) {
				await firebase.firestore()
					.collection('notificationSchedules')
					.doc(id)
					.set(model);
			},
			onNewConsultations: function (onSnapshot, limit) {
				let ref = firebase.firestore()
					.collection('consultations')
					.where('state', '==', 'ConsultationState.request')
					.where('type', '==', 'ConsultationType.init')
					.where('consultantId', '==', null)
					.orderBy('createAt', 'asc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				return ref.onSnapshot(onSnapshot);
			},
			onNewConsultationsForDoctor: function (doctorId, onSnapshot, limit) {
				let ref = firebase.firestore()
					.collection('consultations')
					.where('state', '==', 'ConsultationState.request')
					.where('type', '==', 'ConsultationType.clinic')
					.where('doctorId', '==', doctorId)
					.orderBy('createAt', 'asc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				return ref.onSnapshot(onSnapshot);
			},
			onKeywords: function (onSnapshot) {
				return firebase.firestore()
					.collection('keywords')
					.onSnapshot(onSnapshot);
			},
			loadKeywords: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('keywords');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadKeyword: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('keywords')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addKeyword: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('keywords')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editKeyword: async function (id, model) {
				await firebase.firestore()
					.collection('keywords')
					.doc(id)
					.update(model);
			},
			deleteKeyword: async function (id) {
				await firebase.firestore()
					.collection('keywords')
					.doc(id)
					.delete();
			},
			setKeyword: async function (id, model) {
				await firebase.firestore()
					.collection('keywords')
					.doc(id)
					.set(model);
			},
			onTranslationLanguages: function (onSnapshot) {
				return firebase.firestore()
					.collection('translationLanguages')
					.onSnapshot(onSnapshot);
			},
			loadTranslationLanguages: async function (limit) {
				let itemList = [];
				let ref = firebase.firestore()
					.collection('translationLanguages')
					.orderBy('createAt', 'asc');
				if (limit != null) {
					ref = ref.limit(limit);
				}
				await ref.get()
					.then(async (querySnapshot) => {
						for (let i = 0; i < querySnapshot.docs.length; i++) {
							let itemInfo = querySnapshot.docs[i].data();
							itemInfo.id = querySnapshot.docs[i].id;
							itemList.push(itemInfo);
						}
					});
				return itemList;
			},
			loadTranslationLanguage: async function (id) {
				let item = null;
				await firebase.firestore()
					.collection('translationLanguages')
					.doc(id)
					.get()
					.then(async (documentSnapshot) => {
						if (documentSnapshot.exists) {
							item = documentSnapshot.data();
						}
					});
				return item;
			},
			addTranslationLanguage: async function (model) {
				let newDocRef = firebase.firestore()
					.collection('translationLanguages')
					.doc();
				let addModel = model;
				addModel.id = newDocRef.id;
				await newDocRef.set(addModel);
			},
			editTranslationLanguage: async function (id, model) {
				await firebase.firestore()
					.collection('translationLanguages')
					.doc(id)
					.update(model);
			},
			deleteTranslationLanguage: async function (id) {
				await firebase.firestore()
					.collection('translationLanguages')
					.doc(id)
					.delete();
			},
			setTranslationLanguage: async function (id, model) {
				await firebase.firestore()
					.collection('translationLanguages')
					.doc(id)
					.set(model);
			},
		}
	}
};

Vue.use(database);
